<template>
    <el-form :model="user" ref="registerForm" :rules="rules" label-position="left">
        <!-- <h3 class="login_title">ユーザ登録</h3> -->
        <el-form-item prop="name">
            <el-input type="text" v-model="user.name" auto-complete="off" placeholder="＊名前(必須）"></el-input>
        </el-form-item>
        <el-form-item prop="mailaddress">
            <el-input  v-model="user.mailaddress" auto-complete="off" placeholder="＊メールアドレス(必須）"></el-input>
        </el-form-item>
        <el-form-item prop="mailaddress2">
            <el-input v-model="user.mailaddress2" auto-complete="off" placeholder="＊メールアドレス（必須項目です、確認のため、もう一度入れてください）"></el-input>
        </el-form-item>
        <el-form-item prop="company">
            <el-input v-model="user.company" auto-complete="off" placeholder="会社名"></el-input>
        </el-form-item>
        <el-form-item prop="position">
            <el-input v-model="user.position" auto-complete="off" placeholder="役職"></el-input>
        </el-form-item>
        <el-form-item prop="occupation">
            <el-input v-model="user.occupation" auto-complete="off" placeholder="職種"></el-input>
        </el-form-item>
        <el-form-item prop="telno">
            <el-input v-model="user.telno" auto-complete="off" placeholder="電話番号"></el-input>
        </el-form-item>
        <el-form-item prop="purchasedate">
            <el-date-picker
              v-model="user.purchasedate"
              type="date"
              placeholder="＊購入日（必須）">
            </el-date-picker>
        </el-form-item>
        <el-form-item prop="serid">
            <el-input v-model="user.serid" auto-complete="off" placeholder="＊ライセンス番号（必須）"></el-input>
        </el-form-item>
        <el-form-item prop="voice">
            <el-input type="text" v-model="user.voice" auto-complete="off" placeholder="ご要望"></el-input>
        </el-form-item>
        <el-form-item prop="channel">
            <el-input type="text" v-model="user.channel" auto-complete="off" placeholder="どこからこの製品を初めに知りましたか"></el-input>
        </el-form-item>
        <el-form-item prop="kaptcha">
            <el-input type="text" v-model="user.kaptcha" auto-complete="off" placeholder="＊下記表示されている画像の英文字を入れてください（必須）"></el-input>
        </el-form-item>
        <el-form-item style="width: 100%">
          <!-- add padding-top for IE -->
            <el-image :src="kaptcha" @click="refreshCode" alt="コード作成に失敗しました" style="padding-top: 15px" >
                <div slot="placeholder" class="image-slot">
                    <i class="el-icon-loading"></i>
                </div>
            </el-image>
            <el-link type="primary" @click="refreshCode">検証コードの更新</el-link><br>
            <el-button type="primary" @click="submitForm('registerForm')">登録</el-button>
            <el-button type="primary" @click="reset('registerForm')">リセット</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
export default {
  data: function () {
    var checkEmail = (rule, value, cb) => {
      console.log('checkEmail')
      const regEmail = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/
      if (regEmail.test(value)) {
        return cb()
      }
      cb(new Error('メールアドレスが不正です'))
    }
    var checkEmail2 = (rule, value, cb) => {
      if (this.user.mailaddress === value) {
        return cb()
      }
      cb(new Error('メールアドレスが相違です'))
    }

    return {
      kaptcha: this.$globalConst.APIServiceURL + ':' + this.$globalConst.port + '/kaptcha.jpg?t=' + new Date().getTime(),
      user: {
        name: '',
        mailaddress: '',
        mailaddress2: '',
        company: '',
        position: '',
        occupation: '',
        telno: '',
        purchasedate: '',
        serid: '',
        voice: '',
        channel: '',
        kaptcha: ''
      },
      rules: {
        name: [
          { required: true, message: '名前が必須項目です', trigger: 'blur' }
        ],
        mailaddress: [
          { required: true, message: 'メールアドレスを入力してください', trigger: 'blur' },
          { validator: checkEmail, trigger: 'blur' }
        ],
        mailaddress2: [
          { required: true, message: 'メールアドレスを入力してください', trigger: 'blur' },
          { validator: checkEmail2, trigger: 'blur' }
        ],
        purchasedate: [
          { required: true, message: '購入日をいれてください', trigger: 'blur' }
        ],
        serid: [
          { required: true, message: 'ライセンス番号を入れてください', trigger: 'blur' },
          { min: 6, message: 'ライセンス番号不正です', trigger: 'blur' }
        ],
        kaptcha: [
          { required: true, message: '検証コードを入れてください', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async refreshCode () {
      console.log('refreshcode')
      this.kaptcha = this.$globalConst.APIServiceURL + ':' + this.$globalConst.port + '/kaptcha.jpg?t=' + new Date().getTime()
    },

    submitForm (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          // this.message.success('サブミットしました')
          // Call API
          // curl -i -H "Content-Type:application/json" -d "{\"username\":\"Tom\",\"mailaddress\":\"zhu@gmail.com\",\"telno\":\"89020212\",\"purchasedate\":\"2020-09-12\",\"serid\":\"a2ll2o3840\",\"channel\":\"google\",\"voice\":\"good product\",\"position\":\"director\"}" http://localhost:9090/register
          const webSite = this.$globalConst.APIServiceURL + ':' + this.$globalConst.port + '/register'
          const { data: res } = await this.$http.post(webSite, this.user, { withCredentials: true })
          if (res.code === 'noErr') {
            this.$message.success(res.msg)
          } else {
            this.$message.error(res.msg)
          }
          this.refreshCode()
        } else {
          this.$message.error('項目不正です、訂正してからサブミットしてください')
        }
      })
    },

    reset (formName) {
      this.$refs[formName].resetFields()
      this.refreshCode()
    }

  }

}
</script>

<style scoped>
.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 810px
}
</style>
